import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 bg-[#0F172A] px-4 border-y border-gray-800" data-id="element-166">
      <div className="max-w-3xl mx-auto bg-gray-900 rounded-2xl md:rounded-3xl p-6 md:p-12 border border-cancha/30 shadow-xl text-center relative overflow-hidden" data-id="element-167">
        <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 bg-cancha" data-id="element-168"></div>

        <div className="bg-cancha/15 border border-cancha/30 w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6" data-id="element-169">
          <ShieldCheck className="text-gold w-8 h-8 md:w-10 md:h-10" data-id="element-170" />
        </div>

        <h2 className="font-display text-3xl md:text-4xl text-white mb-2 md:mb-4 uppercase" data-id="element-171">
          7 DÍAS GARANTÍA TOTAL
        </h2>
        <h3 className="text-base md:text-xl font-bold text-gold mb-4 md:mb-6" data-id="element-172">
          7 días para probarlo o te devolvemos el 100%
        </h3>

        <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-4 md:mb-6 max-w-xl mx-auto" data-id="element-173">
          Abrís los tomos, usás los bonos en tu próxima práctica. Si no es lo
          que esperabas: sin preguntas, sin formularios, sin drama.
        </p>

        <p className="text-xs md:text-sm font-bold text-gray-400 bg-gray-800 border border-gray-700 inline-block px-3 md:px-4 py-1.5 md:py-2 rounded-lg" data-id="element-174">
          (Tasa de devoluciones &lt; 1%)
        </p>
      </div>
    </section>;
}